<template>
  <div>
    <h1 class="display-4">Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK</h1><br/>

    <b-row>
      <b-col cols="11">
        <p class="lead">
          <b>
          PROGRAM OBCHODÓW UROCZYSTOŚCI POŚWIĘCONYCH 70 ROCZNICY
          WYBUCHU POWSTANIA WILEŃSKIEGO – OPERACJI WOJSKOWEJ „OSTRA BRAMA” – 7 LIPCA
          </b>
        </p>
      </b-col>
    </b-row>

    <b-button class="btn-white-space" target="_blank" href="http://armiakrajowa-lagiernicy.pl/uroczystosci-poswiecone-69-rocznicy-wybuchu-powstania-wilenskiego-operacji-wojskowej-ostra-brama-wilno-07-lipca-2013r/">
      Uroczystości poświęcone 70 rocznicy wybuchu Powstania Wileńskiego- operacji Wojskowej „Ostra Brama” Wilno – 07 lipca 2014r.
    </b-button>

    <b-row class="mt-3">
      <b-col cols="11">
        <p>
          Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy
          wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz
          Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w
          Wilnie.
        </p>

        <p>
          W obchodach wezmą udział kombatanci – żołnierze Armii Krajowej zPolski, Białorusi i Litwy oraz członkowie Stowarzyszenia,
          nauczyciele wraz zuczniami i harcerzami z patriotycznych szkół w Bujwidzach, Wojdatach, Soleczniakach, Wilnie, Sejnach,
          Suwałkach, Augustowie, Białymstoku, Warszawie, Wołominie i Krakowie.
        </p>

        <p>
          <strong>
            Przybędziemy na Uroczystości pamięci narodowej na cmentarz w Wilnie 7 lipca do sanktuarium „Na Rossie” w 70
            rocznicę wybuchu Powstania Wileńskiego – Operacji „Ostra Brama”, która została zaplanowana w ramach ogólnopolskiej
            „Akcji Burza”, gdzie w dniach od 7 do 13 lipca 1944r stoczyły chwalebny bój z okupantem niemieckim oddziały Armii Krajowej
            pod dowództwem płk Aleksandra Krzyżanowskiego „Wilka”, dowódcy Okręgu Wileńskiego „Wiano”.
          </strong>
        </p>

        <p>
          Przewidziano zakwaterowanie, wyżywienie i transport dla 120 osób, które zostaną przywiezione do Wilnatrzema
          autokarami i w tym 2 busami z 15 kombatantami z Białorusi.
        </p>

        <p>
          Wyjazd wszystkich uczestników do Wilna nastąpi w dniu 05 lipca 2014 r. o godz. 8:00 (sobota) z dworca
          centralnego w Warszawie przy ul Emilii Plater, azakwaterowanie odbędzie się w hoteluCORNER w Wilnie, przy
          ul. Sevcenkos 16, Wilno 3111. Dzielnica: Stare Miasto. Przywitanie przybyłych gości przez Zarząd Główny w
          miejscu zakwaterowania w hoteluCornero godz. 17:30, godz. 18:30 uroczysta kolacja w restauracji hotelu.
          Wieczór wspomnień z udziałem uczestników Akcji „Ostra Brama” żołnierzy AK w sali gościnnej w miejscu zakwaterowania
          godz. 19:30-22:00
        </p>

        <p class="display-4">Dzień I Obchodów</p>
        <p class="lead">Niedziela, 06.07.2014 r.</p>
        <b-row>
          <b-col md="10">
            <ul>
              <li><p>7:30-8:30 - śniadanie</p></li>
              <li>
                <p>
                10:00 - Msza Św. w Kościele Ojców Franciszkanów przy ul. Trockiej modlitwa za zmarłych
                żołnierzy AK z okręgu Wileńskiego i Nowogródzkiego poległych podczas zdobywania Wilna.
                </p>
              </li>
              <li>
                <p>
                12:00 – Główna Uroczystość poświęcona pamięci Powstaniu Wileńskiemu na cmentarzu
                „Na Rossie” z udziałem przedstawicieli władz RP
                </p>
              </li>
              <li><p>14:00-15:00 - obiad w Domu Polskim</p></li>
              <li>
                <p>
                16:00 - dalszy ciąg Uroczystości rocznicowych w Domu Polskim w Wilnie, w ramach którego
                przewidziano wystąpienia, prelekcje oraz montaż teatralno-muzyczny, którego charakter będzie nawiązywał do wydarzeń
                z Powstania Wileńskiego
                </p>
              </li>
              <li><p>19:00-20:00 - uroczysta kolacja przy muzyce w Domu Polskim w Wilnie</p></li>
            </ul>
          </b-col>
        </b-row>

        <p class="display-4">Dzień II Obchodów</p>
        <p class="lead">Poniedziałek, 07.07.2014 r.</p>
        <b-row>
          <b-col md="10">
            <ul>
              <li><p>7:30-8:30 - śniadanie</p></li>
              <li>
                <p>
                  10:00 złożenie przez środowiska kombatanckie oraz zaproszonych gości wieńców i
                  zapalenie zniczy poległym żołnierzom AK w podwileńskich Krawczunach w 70 rocznicę bitwy stoczonej 13 lipca 1944 roku z wojskami
                  niemieckimi dowodzonymi przez gen. Stahela. modlitwa za zmarłych żołnierzy AK z okręgu Wileńskiego i Nowogródzkiego poległych podczas zdobywania Wilna.
                </p>
              </li>
              <li>
                <p>
                12:00 – złożenie wiązanek i zapalenie zniczy w Kalwarii Wileńskiej
                </p>
              </li>
              <li><p>14:00 - uroczysty obiad</p></li>
              <li>
                <p>
                16:00 - przyjazd do kaplicy w Ostrej Bramie z łaskami słynącym obrazem Najświętszej
                Maryi Panny Matki Miłosierdzia- wspólna modlitwa za dusze poległych w boju żołnierzy Armii Krajowej
                </p>
              </li>
              <li><p>17:00 - przyjazd doKościóła św. Piotra i Pawła na Antokolu</p></li>
              <li><p>18:30 - kolacja pożegnalna przy muzyce</p></li>
              <li><p>20:00 - zapalenie zniczy w Kolonii Wileńskiejna grobach poległych żołnierzy AK
                w szturmie na Wilno przez młodzież z Polski i Litwy</p></li>
            </ul>
          </b-col>
        </b-row>

        <p class="display-4">Dzień III Obchodów</p>
        <p class="lead">Wtorek, 08.07.2014 r.</p>
        <b-row>
          <b-col md="10">
            <ul>
              <li><p>7:30-8:30 - śniadanie</p></li>
              <li>
                <p>
                  09:30 modlitwa, a następnie złożenie hołdu pamięci i zapalenie zniczy pomordowanym w
                  Ponarach kilku tysiącom Polaków oraz ponad 80 tysięcy obywateli narodowości żydowskiej i
                  pochodzenia innych narodowości przez okupanta niemieckiego
                </p>
              </li>
              <li>
                <p>
                  10:30 - autokary po Uroczystości składania wieńców w Ponarach
                  odwożą uczestników do Sejn, Białegostoku i Warszawy
                </p>
              </li>
              <li><p>10:30 - wyjazd busaz kombatantami do Lidy na Białoruś</p></li>
            </ul>
          </b-col>
        </b-row>

        <b-card class="text-left">
          <strong>Zarząd Stowarzyszenia</strong>
          <p>
            Andrzej Siedlecki – Prezes<br/>
            Artur Kondrat – Wiceprezes<br/>
            Tel: 505-047-488
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'urocz_w_wilnie',
  metaInfo:{
    title: 'Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK',
    meta:[
      {name: 'description', content: 'Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w Wilnie.' },
      {name: 'og:url', content: 'http://akwilno.pl/urocz_w_wilnie' },
      {name: 'og:title', content: 'Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK' },
      {name: 'og:image', content: '/aktualnosci/urocz_w_wilnie.jpg' },
      {name: 'og:description', content: 'Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w Wilnie.' },
      {name: 'twitter:url', content: 'http://akwilno.pl/urocz_w_wilnie' },
      {name: 'twitter:title', content: 'Uroczystości w Wilnie i zbiórka darów na rzecz żołnierzy AK z Kresów Wschodnich organizowane przez Stowarzyszenie Łagierników Żołnierzy AK' },
      {name: 'witter:image', content: '/aktualnosci/urocz_w_wilnie.jpg' },
      {name: 'twitter:description', content: 'Stowarzyszenie Łagierników Żołnierzy Armii Krajowejwspólnie z Urzędem do Spraw Kombatantów i Osób Represjonowanych przy wsparciu Ministerstwa Spraw Zagranicznych, a także z udziałem Światowego Związku Żołnierzy AK Okręgu Wileńskiego oraz Nowogródzkiego organizuje Uroczystości w dniach od 5 do 8 lipca poświęcone 70 rocznicy operacji Wojskowej „Ostra Brama” w Wilnie.' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/aktualnosci/urocz_w_wilnie.vue